module.exports = __webpack_public_path__ + "img/zhuanhua.7e1e2a82.png";